//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '../../assets/css/editor.css'
import '../../assets/css/quill/quill.snow.css'
import forumobjct from "../script/forumobjct";

var defalut_forum_conf = {
  'release': {
    'buy': true,
    'setting': true
  }
};

export default {
  name: "thread",
  mixins: [forumobjct],
  components: {},
  created() {
    window._t = this;
    this.create_editor();

    this.forums_options = []
    this.update_forums_options(this.$forum_conf.forums, this.forums_options)
  },
  data() {
    return {
      loaded_quill: false,
      editor: undefined,
      title: "",
      relase_loading: false,
      add_buy_content_open: false,
      add_buy_download_open: false,
      add_buy_theav_open: false,
      attach_file_upload: undefined,
      thread: {
        title: "",
        setting: {
          'not_reply': false
        },
        fid: undefined
      },
      buy_download: {
        price: 20
      },
      buy_content: {
        price: 20,
        content: ''
      },
      buy_theav: {
        price: 100,
        id: ''
      },
      post_success: false,
      post_success_tip: "恭喜你，已成功提交，请等待审核通过。",
      edit_id: xx.edit_id,
      show_loading: false,
      forums_options: [],
      forums_options_disabled: false,
      this_form_conf: Object.create(defalut_forum_conf),
      select_forum_conf: undefined,
      show_select_forum_text: undefined
    }
  },
  methods: {
    on_select_forum: function (e) {
      console.log("on_select_forum:", e);
      this.select_forum_conf = e;
      var forum_list = []
      this.show_select_forum_text = ""
      this.get_forum_list(this.select_forum_conf.fid, forum_list);
      for (var i = 0; i < forum_list.length; ++i) {
        this.show_select_forum_text += forum_list[i]['name'] + "/"
      }
      this.show_select_forum_text = this.show_select_forum_text.substr(0, this.show_select_forum_text.length - 1);
    },
    onSubmit: function () {
    },
    onReset: function () {
    },
    create_forum_list: function () {

    },
    add_buy_content: function () {
      this.add_buy_content_open = !this.add_buy_content_open;
    },
    add_buy_theav: function () {
      this.add_buy_theav_open = !this.add_buy_theav_open;
    },
    create_editor: function () {
      console.log('call create_editor');
      var toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],

        [{'header': 1}, {'header': 2}],               // custom button values
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
        [{'direction': 'rtl'}],                         // text direction
        [{'header': [1, 2, 3, 4, 5, 6, false]}],

        [{'color': ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466", 'custom-color']}, {'background': ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466", 'custom-color']}],          // dropdown with defaults from theme
        [{'align': []}],
        ['link', 'image'],
        ['clean']                                         // remove formatting button
      ];
      //var toolbarOptions = [['bold', 'italic'], ['link', 'image']];
      var Quill = window.Quill;
      if (Quill && !this.loaded_quill) {
        this.loaded_quill = true;
      }
      var ImageResize = window.ImageResize;
      if (!Quill || !ImageResize) {
        return setTimeout(this.create_editor, 200);
      }
      this.editor = new Quill('#editor', {
        modules: {
          toolbar: toolbarOptions,
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white',
            },
            displaySize: true,
            //modules: ['Resize', 'DisplaySize', 'Toolbar']
          }
        },
        theme: 'snow',
      });
    }
  }
}
